import type { HelmNavItem } from '@helm/types/helmMainNav'
import { HelmPermission } from '@helm/services/api/client'
import ENV from '@/constants/env'

const HELM_NAV: HelmNavItem[] = [
    {
        label: `Organizations`,
        path: `/organizations`,
        name: `organizations`,
        sideNav: [`organizations`, `organization`],
        permissions: [HelmPermission.HELM_ORGANIZATION_READ]
    },
    {
        label: `Users`,
        path: `/users`,
        name: `users`,
        sideNav: [`users`],
        // Anything in its side nav (Users, Roles, SAML Login) is enough to get the tab.
        permissions: [HelmPermission.HELM_USER_READ, HelmPermission.HELM_USER_WRITE, HelmPermission.HELM_CONFIG]
    },
    {
        label: `Messaging`,
        path: `/messaging`,
        name: `messaging`,
        sideNav: [`messaging`]
    },
    {
        label: `Config`,
        path: `/config`,
        name: `config`,
        sideNav: [`config`]
    },
    {
        label: `Laravel Horizon`,
        path: `https://api.${ENV.helmDomain()}/horizon`,
        target: `_blank`,
        permissions: [HelmPermission.HELM_HORIZON]
    },
    {
        label: 'Command Center',
        path: `https://x.${ENV.helmDomain()}/login?helm&continue=/commandcenter/search`,
        target: `_blank`,
        commandCenterLinked: true
    }
]

export default HELM_NAV
